"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/admin_common.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminBrandUserDetail = exports.AdminTenantUserDetail = exports.AdminBrandUserRole = exports.AdminUserBasicInfo = exports.AdminBrand = exports.AdminBankAccount = exports.AdminCreator = exports.AdminCorporationInfo = exports.AdminIndividualInfo = exports.AdminCreatorCore = exports.AdminUser = exports.AdminBrandPublishStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * 販売元の公開ステータス
 *
 * @generated from enum spwn.account.v1.AdminBrandPublishStatus
 */
var AdminBrandPublishStatus;
(function (AdminBrandPublishStatus) {
    /**
     * @generated from enum value: ADMIN_BRAND_PUBLISH_STATUS_UNSPECIFIED = 0;
     */
    AdminBrandPublishStatus[AdminBrandPublishStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 公開
     *
     * @generated from enum value: ADMIN_BRAND_PUBLISH_STATUS_PUBLISHED = 1;
     */
    AdminBrandPublishStatus[AdminBrandPublishStatus["PUBLISHED"] = 1] = "PUBLISHED";
    /**
     * 非公開
     *
     * @generated from enum value: ADMIN_BRAND_PUBLISH_STATUS_UNPUBLISHED = 2;
     */
    AdminBrandPublishStatus[AdminBrandPublishStatus["UNPUBLISHED"] = 2] = "UNPUBLISHED";
})(AdminBrandPublishStatus || (exports.AdminBrandPublishStatus = AdminBrandPublishStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(AdminBrandPublishStatus)
protobuf_1.proto3.util.setEnumType(AdminBrandPublishStatus, "spwn.account.v1.AdminBrandPublishStatus", [
    { no: 0, name: "ADMIN_BRAND_PUBLISH_STATUS_UNSPECIFIED" },
    { no: 1, name: "ADMIN_BRAND_PUBLISH_STATUS_PUBLISHED" },
    { no: 2, name: "ADMIN_BRAND_PUBLISH_STATUS_UNPUBLISHED" },
]);
/**
 * @generated from message spwn.account.v1.AdminUser
 */
class AdminUser extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_firestore_id = 1;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string email = 2;
         */
        this.email = "";
        /**
         * @generated from field: bool disabled = 3;
         */
        this.disabled = false;
        /**
         * @generated from field: int64 created_at = 5;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminUser().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUser().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUser().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminUser, a, b);
    }
}
exports.AdminUser = AdminUser;
AdminUser.runtime = protobuf_1.proto3;
AdminUser.typeName = "spwn.account.v1.AdminUser";
AdminUser.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "last_refresh_time", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "is_redeemer", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
]);
/**
 * @generated from message spwn.account.v1.AdminCreatorCore
 */
class AdminCreatorCore extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_slug = 1;
         */
        this.brandSlug = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string icon_thumbnail = 3;
         */
        this.iconThumbnail = "";
        /**
         * ユーザーのFirestore Auth ID
         *
         * @generated from field: string user_firestore_id = 4;
         */
        this.userFirestoreId = "";
        /**
         * ユーザーのRDB ID
         *
         * @generated from field: string user_id = 5;
         */
        this.userId = "";
        /**
         * @generated from field: int64 registered_at = 6;
         */
        this.registeredAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminCreatorCore().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreatorCore().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreatorCore().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminCreatorCore, a, b);
    }
}
exports.AdminCreatorCore = AdminCreatorCore;
AdminCreatorCore.runtime = protobuf_1.proto3;
AdminCreatorCore.typeName = "spwn.account.v1.AdminCreatorCore";
AdminCreatorCore.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "registered_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminIndividualInfo
 */
class AdminIndividualInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int64 date_of_birth = 1;
         */
        this.dateOfBirth = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminIndividualInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminIndividualInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminIndividualInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminIndividualInfo, a, b);
    }
}
exports.AdminIndividualInfo = AdminIndividualInfo;
AdminIndividualInfo.runtime = protobuf_1.proto3;
AdminIndividualInfo.typeName = "spwn.account.v1.AdminIndividualInfo";
AdminIndividualInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "date_of_birth", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminCorporationInfo
 */
class AdminCorporationInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string corporation_name = 1;
         */
        this.corporationName = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminCorporationInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCorporationInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCorporationInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminCorporationInfo, a, b);
    }
}
exports.AdminCorporationInfo = AdminCorporationInfo;
AdminCorporationInfo.runtime = protobuf_1.proto3;
AdminCorporationInfo.typeName = "spwn.account.v1.AdminCorporationInfo";
AdminCorporationInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "corporation_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.account.v1.AdminCreator
 */
class AdminCreator extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string representative_name = 2;
         */
        this.representativeName = "";
        /**
         * @generated from oneof spwn.account.v1.AdminCreator.additional_info
         */
        this.additionalInfo = { case: undefined };
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminCreator().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminCreator().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminCreator().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminCreator, a, b);
    }
}
exports.AdminCreator = AdminCreator;
AdminCreator.runtime = protobuf_1.proto3;
AdminCreator.typeName = "spwn.account.v1.AdminCreator";
AdminCreator.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "core_data", kind: "message", T: AdminCreatorCore },
    { no: 2, name: "representative_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "individual", kind: "message", T: AdminIndividualInfo, oneof: "additional_info" },
    { no: 4, name: "corporation", kind: "message", T: AdminCorporationInfo, oneof: "additional_info" },
]);
/**
 * @generated from message spwn.account.v1.AdminBankAccount
 */
class AdminBankAccount extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * 銀行名
         *
         * @generated from field: string bank_name = 1;
         */
        this.bankName = "";
        /**
         * 支店名
         *
         * @generated from field: string branch_name = 2;
         */
        this.branchName = "";
        /**
         * 口座種別
         *
         * @generated from field: string account_type = 3;
         */
        this.accountType = "";
        /**
         * 口座番号
         *
         * @generated from field: string account_number = 4;
         */
        this.accountNumber = "";
        /**
         * 口座名義（カナ）
         *
         * @generated from field: string account_holder_kana = 5;
         */
        this.accountHolderKana = "";
        /**
         * @generated from field: int64 created_at = 6;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 updated_at = 7;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminBankAccount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminBankAccount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminBankAccount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminBankAccount, a, b);
    }
}
exports.AdminBankAccount = AdminBankAccount;
AdminBankAccount.runtime = protobuf_1.proto3;
AdminBankAccount.typeName = "spwn.account.v1.AdminBankAccount";
AdminBankAccount.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "bank_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "account_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "account_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "account_holder_kana", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminBrand
 */
class AdminBrand extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string tenant_id = 1;
         */
        this.tenantId = "";
        /**
         * @generated from field: string brand_id = 2;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_firestore_id = 3;
         */
        this.brandFirestoreId = "";
        /**
         * @generated from field: string name = 4;
         */
        this.name = "";
        /**
         * @generated from field: string slug = 5;
         */
        this.slug = "";
        /**
         * @generated from field: spwn.account.v1.AdminBrandPublishStatus publish_status = 9;
         */
        this.publishStatus = AdminBrandPublishStatus.UNSPECIFIED;
        /**
         * @generated from field: int64 created_at = 10;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 updated_at = 11;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminBrand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminBrand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminBrand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminBrand, a, b);
    }
}
exports.AdminBrand = AdminBrand;
AdminBrand.runtime = protobuf_1.proto3;
AdminBrand.typeName = "spwn.account.v1.AdminBrand";
AdminBrand.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "icon_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "cover_thumbnail", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "publish_status", kind: "enum", T: protobuf_1.proto3.getEnumType(AdminBrandPublishStatus) },
    { no: 10, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminUserBasicInfo
 */
class AdminUserBasicInfo extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string user_firestore_id = 2;
         */
        this.userFirestoreId = "";
        /**
         * @generated from field: string full_name = 3;
         */
        this.fullName = "";
        /**
         * @generated from field: string email = 4;
         */
        this.email = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminUserBasicInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminUserBasicInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminUserBasicInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminUserBasicInfo, a, b);
    }
}
exports.AdminUserBasicInfo = AdminUserBasicInfo;
AdminUserBasicInfo.runtime = protobuf_1.proto3;
AdminUserBasicInfo.typeName = "spwn.account.v1.AdminUserBasicInfo";
AdminUserBasicInfo.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_firestore_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "full_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: protobuf_1.Timestamp },
]);
/**
 * @generated from message spwn.account.v1.AdminBrandUserRole
 */
class AdminBrandUserRole extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string brand_id = 1;
         */
        this.brandId = "";
        /**
         * @generated from field: string brand_name = 2;
         */
        this.brandName = "";
        /**
         * @generated from field: string brand_slug = 3;
         */
        this.brandSlug = "";
        /**
         * @generated from field: string role = 4;
         */
        this.role = "";
        /**
         * @generated from field: int64 created_at = 5;
         */
        this.createdAt = protobuf_1.protoInt64.zero;
        /**
         * @generated from field: int64 updated_at = 6;
         */
        this.updatedAt = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminBrandUserRole().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminBrandUserRole().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminBrandUserRole().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminBrandUserRole, a, b);
    }
}
exports.AdminBrandUserRole = AdminBrandUserRole;
AdminBrandUserRole.runtime = protobuf_1.proto3;
AdminBrandUserRole.typeName = "spwn.account.v1.AdminBrandUserRole";
AdminBrandUserRole.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "brand_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "brand_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "brand_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "updated_at", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.account.v1.AdminTenantUserDetail
 */
class AdminTenantUserDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated spwn.account.v1.AdminBrandUserRole brand_user_roles = 2;
         */
        this.brandUserRoles = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminTenantUserDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminTenantUserDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminTenantUserDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminTenantUserDetail, a, b);
    }
}
exports.AdminTenantUserDetail = AdminTenantUserDetail;
AdminTenantUserDetail.runtime = protobuf_1.proto3;
AdminTenantUserDetail.typeName = "spwn.account.v1.AdminTenantUserDetail";
AdminTenantUserDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "basic_info", kind: "message", T: AdminUserBasicInfo },
    { no: 2, name: "brand_user_roles", kind: "message", T: AdminBrandUserRole, repeated: true },
]);
/**
 * @generated from message spwn.account.v1.AdminBrandUserDetail
 */
class AdminBrandUserDetail extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string role = 2;
         */
        this.role = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AdminBrandUserDetail().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AdminBrandUserDetail().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AdminBrandUserDetail().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(AdminBrandUserDetail, a, b);
    }
}
exports.AdminBrandUserDetail = AdminBrandUserDetail;
AdminBrandUserDetail.runtime = protobuf_1.proto3;
AdminBrandUserDetail.typeName = "spwn.account.v1.AdminBrandUserDetail";
AdminBrandUserDetail.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "basic_info", kind: "message", T: AdminUserBasicInfo },
    { no: 2, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=admin_common_pb.js.map